import { Box, Flex } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SmallHeading } from '../../texts/SmallHeading/smallHeading';

export interface ITag {
	content: any;
	value: string;
}

interface ITagSelector {
	tags: ITag[];
	label?: string;
	name: string;
	selected?: any[];
}

export const TagSelector: FC<ITagSelector> = ({ tags, label, name, selected }) => {
	const { setFieldValue } = useFormikContext();
	const { t } = useTranslation();
	const [selectedTags, setSelectedTags] = useState<any[]>(selected ? selected : [tags[0].value]);

	const clickTag = (value: string) => {
		if (selectedTags.includes(value)) {
			setSelectedTags(state => state.filter(state => state != value));
		} else {
			setSelectedTags(state => [...state, value]);
		}
	};

	useEffect(() => {
		setFieldValue(name, selectedTags);
	}, [selectedTags]);

	return (
		<Box mt="15px">
			<SmallHeading
				text={label ? label : ''}
				warningText={t('form.headers.tags.category.description')}
				info
			/>
			<Flex
				gridGap="8px"
				flexWrap="wrap"
				m="14px 0px"
			>
				{tags.map(el => {
					return (
						<Box
							key={el.value}
							borderRadius="4px"
							cursor="pointer"
							onClick={() => clickTag(el.value)}
							fontSize="14px"
							lineHeight="90%"
							padding="8px 12px"
							bg={selectedTags.includes(el.value) ? '#FF3F3F' : '#272727'}
							border="1px solid"
							borderColor={selectedTags.includes(el.value) ? '#FF3F3F' : '#4E4F52'}
							color={selectedTags.includes(el.value) ? 'white' : '#686868'}
						>
							{el.content}
						</Box>
					);
				})}
			</Flex>
		</Box>
	);
};
